import { BALL, FIELD, goalMouth, type Ball, type TeamSide } from "@golazo/shared";


export function defendedGoalX(side: TeamSide): number {
  return side === "home" ? 0 : FIELD.WIDTH;
}

/**
 * Altura a la que el balon cruzara la linea de gol `goalX`, o `null` si no va
 * a llegar entre los postes.
 */
export function predictGoalLineCrossing(ball: Ball, goalX: number): number | null {
  const reachX = ball.vel.x / BALL.FRICTION_EFFECTIVE;
  if (Math.abs(reachX) < 1e-3) return null;

  const progress = (goalX - ball.pos.x) / reachX;
  if (progress <= 0 || progress >= 1) return null;

  const y = ball.pos.y + (ball.vel.y / BALL.FRICTION_EFFECTIVE) * progress;
  const mouth = goalMouth();
  if (y < mouth.top || y > mouth.bottom) return null;

  return y;
}

/** El balon va hacia la porteria que defiende `side`. */
export function isBallHeadingToGoal(ball: Ball, side: TeamSide): boolean {
  const goalX = defendedGoalX(side);
  const minSpeed = 40;
  const toward = side === "home" ? ball.vel.x < -minSpeed : ball.vel.x > minSpeed;
  if (!toward) return false;
  return predictGoalLineCrossing(ball, goalX) !== null;
}

/** Balon en la zona donde el portero puede activar parada. */
export function isInSaveZone(ball: Ball, side: TeamSide): boolean {
  const depth = side === "home" ? ball.pos.x : FIELD.WIDTH - ball.pos.x;
  return depth < FIELD.WIDTH * 0.38;
}
